import React from 'react'
import {
    Accordion,
    AccordionHeader,
    AccordionBody,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
} from "@material-tailwind/react";
import '../../styles/cardStyles.css';



function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
}

const PackageCard = ({ PackagesDetails }) => {

    const [open, setOpen] = React.useState(0);

    const handleOpen = (value) => setOpen(open === value ? 0 : value);

    return (
        <>
            <Card className="shadow-lg rounded-none hover:shadow-lg hover:shadow-black/30 transition-shadow duration-500 data-card">
                <CardHeader className="relative rounded-none mt-6 h-60 object-cover">
                    <img
                        src={PackagesDetails.src}
                        alt={PackagesDetails.alt}
                        className='object-cover w-full h-full card-thumbnail'
                    />
                </CardHeader>
                <CardBody>
                    {/* <Typography variant="h5" color="blue-gray" className="mb-2">
                        {PackagesDetails.title}
                    </Typography> */}
                    {/* <Typography>
                        {PackagesDetails.description}
                    </Typography> */}

                    <Accordion open={open === PackagesDetails.cardId} icon={<Icon id={PackagesDetails.cardId} open={open} />}>
                        <AccordionHeader onClick={() => handleOpen(PackagesDetails.cardId)}>
                            <Typography variant="h5" color="blue-gray" className="mb-2 text_PlayfairDisplay-VariableFont_wght">
                                {PackagesDetails.title}
                            </Typography>
                        </AccordionHeader>
                        <AccordionBody className='description_AlegreyaSans-Light leading-tight font-medium text-black'>
                            {PackagesDetails.description}
                        </AccordionBody>
                    </Accordion>

                </CardBody>
                {/* <CardFooter className="pt-0">
                <Button>Read More</Button>
            </CardFooter> */}
            </Card>
        </>
    );
}

export default PackageCard